import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../store/ApplicationState";
import {
  DocumentDownloadActionDispatchTypes,
  DocumentListDispatchTypes,
  GeneralInfoDispatchTypes,
  NotesListDispatchTypes,
  NotesViewDispatchTypes,
  RequestDetailsDispatchTypes,
} from "../models/DispatchTypes/AuthorizationDetailstab";
import {
  GeneralInfoActionDispatchTypes,
  NotesListActionDispatchTypes,
  NotesViewActionDispatchTypes,
  RequestDetailsActionDispatchTypes,
} from "../constants/Authorization";
import {
  GetDocumentDownload,
  GetDocumentList,
  GetGeneralInfo,
  GetNotesList,
  GetNotesViewByDisciplineNoteId,
  GetNoteView,
  GetRequestDetails,
} from "../services/AuthorizationDetailstab";
import { DocumentDownloadDispatchTypes, DocumentListActionDispatchTypes } from "../constants/Document";
import { baseUrl } from "../constants/Config";

export const getGeneralInfo: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    GeneralInfoDispatchTypes
  >
> = (referralId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GeneralInfoActionDispatchTypes.GENERAL_INFO_INVOKE,
    });

    const response = await GetGeneralInfo(baseUrl, referralId);

    dispatch({
      response: response,
      type: GeneralInfoActionDispatchTypes.GENERAL_INFO_SUCCESS,
    });
  };
};

export const getRequestDetails: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    RequestDetailsDispatchTypes
  >
> = (referralId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: RequestDetailsActionDispatchTypes.REQUEST_DETAILS_INVOKE,
    });
    const response = await GetRequestDetails(baseUrl, referralId);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: RequestDetailsActionDispatchTypes.REQUEST_DETAILS_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: RequestDetailsActionDispatchTypes.REQUEST_DETAILS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getDocumentList: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DocumentListDispatchTypes
  >
> = (referralId: number, type: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DocumentListActionDispatchTypes.GET_DOCUMENT_LIST_INVOKE,
    });

    const response = await GetDocumentList(
      baseUrl ,
      referralId,
      type
    );
    dispatch({
      response: response,
      type: DocumentListActionDispatchTypes.GET_DOCUMENT_LIST_SUCCESS,
    });
  };
  };

export const documentDownload: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DocumentDownloadActionDispatchTypes>
> = (blobId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DocumentDownloadDispatchTypes.GET_DOCUMENT_DOWNLOAD_INVOKE,
    });

    const response = await GetDocumentDownload(
      baseUrl,
      blobId,
      "file"
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            response,
            type: DocumentDownloadDispatchTypes.GET_DOCUMENT_DOWNLOAD_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: {
              blob: response.data,
              headers: response.headers,
            },
            type: DocumentDownloadDispatchTypes.GET_DOCUMENT_DOWNLOAD_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getNotesList: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    NotesListDispatchTypes
  >
> = (referralId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: NotesListActionDispatchTypes.NOTES_LIST_INVOKE,
    });
    const response = await GetNotesList(baseUrl, referralId);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: NotesListActionDispatchTypes.NOTES_LIST_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: NotesListActionDispatchTypes.NOTES_LIST_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getNotesView: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    NotesViewDispatchTypes
  >
> = (referralNoteId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: NotesViewActionDispatchTypes.NOTES_VIEW_INVOKE,
    });
    const response = await GetNoteView(baseUrl, referralNoteId);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: NotesViewActionDispatchTypes.NOTES_VIEW_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: NotesViewActionDispatchTypes.NOTES_VIEW_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getNotesViewByDisciplineNoteId: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    NotesViewDispatchTypes 
  >
> = (disciplineNoteId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: NotesViewActionDispatchTypes.NOTES_VIEW_INVOKE,
    });
    const response = await GetNotesViewByDisciplineNoteId(baseUrl, disciplineNoteId);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: NotesViewActionDispatchTypes.NOTES_VIEW_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: NotesViewActionDispatchTypes.NOTES_VIEW_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};